import React, { useState } from 'react'

import { useAccountSettings } from 'redux/hooks/SignedInAccount'
import { useTranslation } from 'language/translator'

import Button from 'components_new/atoms/Button'

import EmptyPlaceholder from 'components_new/molecules/EmptyPlaceholder'
import SectionHeader from 'components_new/molecules/SectionHeader'
import SidebarDialog from 'components_new/molecules/SidebarDialog'

import GroupList from 'components_new/organisms/GroupList'

import { TGroup } from 'types/GlobalGroup'

interface GroupsDialogProps {
  groups: Omit<TGroup, 'key_metrics'>[] // @TODO!
  onAdd: (id: string) => void
  onClose: () => void
  onRemove: (id: string) => void
  open: boolean
}

const GroupsDialog = (props: GroupsDialogProps) => {
  const { groups, onAdd, onClose, onRemove, open } = props

  const { isAdmin } = useAccountSettings()
  const { t } = useTranslation()

  const [editMode, setEditMode] = useState<boolean>(false)

  const handleClose = () => {
    onClose()
    setEditMode(false)
  }

  return (
    <SidebarDialog
      actions={
        <Button onClick={handleClose} variant="text">
          {t('global', 'close')}
        </Button>
      }
      PaperProps={{ sx: { height: '60vh' } }}
      maxWidth="xs"
      onClose={handleClose}
      open={open}
    >
      {/*-- groups --*/}
      <SectionHeader
        actions={
          groups.length > 0 && isAdmin ? (
            <Button
              onClick={() => setEditMode(!editMode)}
              size="small"
              variant={editMode ? 'contained' : 'text'}
            >
              {editMode ? t('global', 'done') : t('global', 'edit')}
            </Button>
          ) : undefined
        }
        divider={true}
        gutterBottom={true}
        title={t('global', 'groups')}
      />

      <GroupList
        editMode={editMode || (groups.length === 0 && isAdmin)}
        groups={groups as TGroup[] /* $TODO */}
        onAdd={onAdd}
        onRemove={onRemove}
      />

      {/*-- empty --*/}
      {groups.length === 0 && !editMode ? (
        <EmptyPlaceholder
          background={true}
          body={t('key_metrics', 'no_groups_body')}
          size="small"
          title={t('key_metrics', 'no_groups_title')}
          sx={{ flex: 1 }}
        />
      ) : null}
    </SidebarDialog>
  )
}

export default GroupsDialog
